<template>
  <v-container fluid>
    <div class="row">
      <div class="mb-4">
        <MonthFilters
          :end="dateEnd"
          :start="dateStart"
          @getDates="getDates"
          :excludePeriod="excludePeriod"
          :defaultPeriod="defaultPeriod"
          :setDates="true"
          :disabled="loaded"
        />
      </div>
    </div>
    <p class="mt-4 text-center" v-if="hasDownloadError && !loaded">Error at loading report</p>
    <p class="mt-4 text-center" v-if="loaded">Loading... Please wait</p>
    <div v-if="!hasDownloadError && !loaded">
      <div class="row">
      <div class="col-4">
        <div class="row elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme--light">
          <div class="col-7"><b class="pr-1">Total Expenses </b></div>
          <div class="col-5 text-right  ">${{ data.expenses.total | formatPrice }}</div>
        </div>
      </div>
      <div class="col-4">
        <div class="row elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme--light">
          <div class="col-7"><b class="pr-1">Google Ads Expenses </b></div>
          <div class="col-5 text-right  ">${{ data.expenses.google | formatPrice }}</div>
        </div>
      </div>
      <div class="col-4">
        <div class="row elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme--light">
          <div class="col-7"><b class="pr-1">Bing Ads Expenses </b></div>
          <div class="col-5 text-right  ">${{ data.expenses.bing | formatPrice }}</div>
        </div>
      </div>
    </div>
      <div class="row">
        <div class="col-6">
          <h2 class="mb-4">Conversion Rate</h2>
          <div class="row elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme--light">
            <div id="conversationFunnel" class="col-12" style="max-height: 420px"></div>
          </div>
        </div>
        <div class="col-6">
          <h2 class="mb-4">New Customer</h2>
          <div class="row elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme--light">
            <div id="newCustomerFunnel" class="col-12" style="max-height: 420px"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <h2 class="mb-4">Orders</h2>
          <div class="elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme--light">
            <p class="text-h6 mb-4">Total Orders: <strong>{{ marketingActivityData.orders.total_orders || 0 }}</strong></p>
            <div id="ordersPieChart" style="height: 500px; min-height: 500px"></div>
          </div>
        </div>
        <div class="col-6">
          <h2 class="mb-4">Quotes</h2>
          <div class="elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme--light">
            <p class="text-h6 mb-4">Total Quotes: <strong>{{ marketingActivityData.quotes.total_quotes || 0 }}</strong></p>
            <div id="quotesPieChart" style="height: 500px; min-height: 500px"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 d-none">
        <h2 class="mb-4"><a href="#" target="_blank" @click="openCrmReport">CRM Report</a></h2>
          <div class="row elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme--light">
            <div class="col-12">
                  <v-row class="pa-0">
                    <v-progress-linear indeterminate color="indigo" v-if="loadedCopper"></v-progress-linear>
                    <v-col cols="12" class="d-flex justify-start" v-for="(e, i) in statisticСards" :key="i">
                      <div class="d-flex flex-column">
                        <div class="d-flex align-end" v-for="(card, index) in statisticСards[i]" :key="index">
                          <b class="pr-1">{{card.title}}: </b>
                          <span v-if="!loadedCopper && card.filter === 'formatPrice'">${{ dataTotalsCopper[card.value] | formatPrice }}</span>
                          <span v-if="!loadedCopper && card.filter === 'formatFloat'">{{ dataTotalsCopper[card.value] | formatFloat }}</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
            </div>
          </div>
      </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h2 class="mb-4">Relevancy traffic</h2>
          <div class="row elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme--light">
            <div id="relevancyBar" class="col-6" style="max-height: 420px"></div>
            <div id="relevancyFunnel" class="col-6" style="max-height: 420px"></div>
          </div>
        </div>
      </div>

            <div class="row">
        <div class="col-12 d-none">
          <h2 class="mb-4">Social Media followers</h2>
          <div class="row elevation-2 p-6 m-4 rounded-lg v-card v-sheet theme&#45;&#45;light">
            <div class="col-12 mb-4 d-md-flex">
              <v-switch
                  v-model="isCompareFilter"
                  hide-details
                  color="orange darken-3"
              >
                <template #label>
                  <span class="ml-1">Compare</span>
                </template>
              </v-switch>
             <div style="width:200px; margin-top: -15px">
                <DateFilter v-if="isCompareFilter" class="ml-2" style="display: inline-block" @getDates="(e) => {getCompareDates({dateStart:e.dateStart, dateEnd:e.dateStart})}"/>
             </div>
            </div>
            <div id="socialBar" class="col-12"></div>
            <highcharts :options="socialBar" class="col-12"></highcharts>
          </div>
        </div>
      </div>

    </div>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import MonthFilters from '@/components/filters/RangePicker'
import Highcharts from 'highcharts'
import DateFilter from "../../components/filters/DateFilter";
export default {
  components: {
    MonthFilters,
      DateFilter,
  },
  props: ["ads"],
  data() {
    return {
      hasDownloadError: false,
      loaded: true,
      isCompareFilter: true,
      compareIcon: 'mdi-compare-vertical',
      compareFilterColor: 'orange darken-3',
      diffDays: 0,
      data: {
        expenses: { total: 0, google: 0, bing: 0},
        leads: {visits: 0, new: 0, cost: 0},
        conversion: {visits: 0, leads: 0, orders: 0, customers: 0},
        relevancy: {call: 0, web: 0, quotes:0 },
        media: {facebook: 0, instagram: 0, linkedin: 0, youtube:0, twitter: 0}
      },
      dataCompare: {
        expenses: { total: 0, google: 0, bing: 0},
        leads: {visits: 0, new: 0, cost: 0},
        conversion: {visits: 0, leads: 0, orders: 0, customers: 0},
        relevancy: {call: 0, web: 0, quotes:0 },
        media: {facebook: 0, instagram: 0, linkedin: 0, youtube:0, twitter: 0}
      },
      monthNames: ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"],
      excludePeriod: [],
      defaultPeriod: 4,
      socialBar:{
          chart: {
            type: 'bar',
            height: 500
          },
          title:"",
          xAxis: {
              categories: ['Facebook', 'Instagram', 'LinkedIn', 'Youtube', 'Twitter'],
              title: {
                  text: null
              }
          },
          yAxis: {
              min: 0,
              title: {
                  text: 'Number of followers',
                  align: 'high'
              },
              labels: {
                  overflow: 'justify'
              }
          },
          tooltip: {
              valueSuffix: ' followers'
          },
          plotOptions: {
              bar: {
                 dataLabels: {
                    format: '<b>{point.name}</b> ({point.y})',
                    enabled: true,
                    color: 'black',
                    align: 'right',
                    style: {
                        fontSize: '10px',
                        fontFamily: 'helvetica, arial, sans-serif',
                        textShadow: false,
                        fontWeight: 'normal',
                        textOutline: false
                    }
                }
              },
          },
                legend: {
          enabled: false
        },
          series: []
      },
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      dateEnd: new Date().toISOString().substr(0, 10),
      dateCompareEnd: new Date(
                        Date.UTC(
                            new Date().getFullYear(),
                            new Date().getMonth(),
                            0
                            )).toISOString().substr(0, 10),
      dateCompareStart: new Date(
                          Date.UTC(
                              new Date().getFullYear(),
                              new Date().getMonth()-1,
                              0
                              )).toISOString().substr(0, 10),
      statisticFiltered: {
        potential: 0,
        converted: 0,
        totalValue: 0,
        totalGallons: 0
      },
      loadedCopper: false,
      statisticСards: [
        [
          {title: '# of created open quotes', value: 'createdQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
          {title: '# of open quotes', value: 'openQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
          {title: '# of converted quotes', value: 'convertedQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
        ],
        [
          {title: '# of lost quotes', value: 'lostQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
          {title: '# of abandoned quotes', value: 'abandonedQuotes', loaded: 'loadedCopper', filter: 'formatFloat'},
        ],
        [
          {title: '# CRM Leads', value: 'new_leads', loaded: 'loadedCopper', filter: 'formatFloat', filtered: true},
          {title: '# converted leads to people', value: 'converted', loaded: 'loadedCopper', filter: 'formatFloat', filtered: true},
        ]
      ],
      dataTotalsCopper: {
        createdOpenOpportunity: 0,
        createdOpportunity: 0,
        createdPeople: 0,
        leadToPeople: 0,
        openToWon: 0,
        converted: 0,
        potential: 0,
          new_leads:0,
        totalValue: 0,
        totalGallons: 0,
        stillOpenOpportunity: 0
      },
      // Marketing Activity data
      marketingActivityData: {
        conversionRate: {
          ppc_impressions: 0,
          ppc_clicks: 0,
          fo_events: 0,
          unique_inbound_traffic: 0,
          orders: 0
        },
        orders: {
          total_orders: 0,
          converted_lead_to_customer: 0,
          new_customer: 0,
          recurrent_customer: 0
        },
        quotes: {
          total_quotes: 0,
          converted_quotes: 0,
          open_quotes: 0,
          lost_quotes: 0
        },
        customersLeads: {
          fo_events_count: 0,
          fo_new_leads_count: 0,
          fo_new_customers_count: 0
        }
      },
      loadedMarketingActivity: false,
    }
  },
  watch: {
     isCompareFilter(){
      this.applayCompares()
     }
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    if (localStorage.getItem('fromCounterPage')) {
      let data = JSON.parse(localStorage.getItem('fromCounterPage'))
      this.dateStart = data.dateStart
      this.dateEnd = data.dateEnd
      this.defaultPeriod = data.defaultPeriod
      localStorage.removeItem('fromCounterPage')
    }

    this.loadReports()
  },
  computed: {
  },
  methods: {
    getCompareDates(dates){
      this.dateCompareStart = dates.dateStart
      this.dateCompareEnd = dates.dateEnd
      this.applayCompares()
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.applyFilters()
    },
    applyFilters(){
      this.loadReports()
    },
    applayCompares(){
      this.loadCompareReports()
    },
    openCrmReport(){
      let data = JSON.stringify({
        report: 'crmReport',
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        defaultPeriod: this.defaultPeriod
      })
      localStorage.setItem('orders', data)

      let routeData = this.$router.resolve({name: 'copper-report'})
      window.open(routeData.href, '_blank')
    },
    loadReports() {
      this.loaded = true
      this.loadedCopper = true;
      this.loadedMarketingActivity = true;

      axios
        .get('/reports/marketing-summary/' +  this.dateStart + '/' + this.dateEnd )
        .then(response => {
          this.hasDownloadError = false
          this.loaded = false
          this.data = response.data.data
            this.dataTotalsCopper.new_leads = this.data.leads.new
          this.$nextTick(()=>{
            this.drawRelevanceBar()
            this.drawConversationBar()
            this.drawSocialBar()
            // Draw Marketing Activity diagrams - will be called again when data loads
            this.drawNewCustomerFunnel()
            this.drawOrdersPieChart()
            this.drawQuotesPieChart()
          })
        }).catch((e)=>{
          console.log(e)
          this.loaded = false
          this.hasDownloadError = true
      });

      axios
          .get('/reports/copper/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {

            this.dataLeadsToPeople = response.data.leads_to_people
            this.dataLeadsToPotential = response.data.leads_to_potential
            this.dataOpportunityCopper = response.data.opportunity


            this.dataTotalsCopper.createdQuotes = this.dataOpportunityCopper.filter(e=>e.status !== "Won").length
            this.dataTotalsCopper.wonQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Won").length
            this.dataTotalsCopper.openQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Open").length
            this.dataTotalsCopper.convertedQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Converted").length
            this.dataTotalsCopper.lostQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Lost").length
            this.dataTotalsCopper.abandonedQuotes = this.dataOpportunityCopper.filter(e=>e.status === "Abandoned").length

            this.dataTotalsCopper.converted = this.dataLeadsToPeople.length
            this.dataTotalsCopper.potential = this.dataLeadsToPotential.length

            this.dataOpportunityCopper = this.dataOpportunityCopper.filter(e=>e.status !== "Won")

            this.loadedCopper = false
          })

      // Load Marketing Activity Reports
      this.loadMarketingActivityReports();
    },
    loadMarketingActivityReports() {
      // Load Conversion Rate Report
      axios
        .get('/reports/marketing-activity/conversion-rate/' + this.dateStart + '/' + this.dateEnd)
        .then(response => {
          this.marketingActivityData.conversionRate = response.data.data
          console.log('Marketing Activity - Conversion Rate:', response.data.data)
        })
        .catch(e => {
          console.error('Error loading conversion rate report:', e)
        });

      // Load Orders Report
      axios
        .get('/reports/marketing-activity/orders/' + this.dateStart + '/' + this.dateEnd)
        .then(response => {
          this.marketingActivityData.orders = response.data.data
          console.log('Marketing Activity - Orders:', response.data.data)
          // Draw the Orders pie chart after data is loaded
          this.$nextTick(() => {
            this.drawOrdersPieChart()
          })
        })
        .catch(e => {
          console.error('Error loading orders report:', e)
        });

      // Load Quotes Report
      axios
        .get('/reports/marketing-activity/quotes/' + this.dateStart + '/' + this.dateEnd)
        .then(response => {
          this.marketingActivityData.quotes = response.data.data
          console.log('Marketing Activity - Quotes:', response.data.data)
          // Draw the Quotes pie chart after data is loaded
          this.$nextTick(() => {
            this.drawQuotesPieChart()
          })
        })
        .catch(e => {
          console.error('Error loading quotes report:', e)
        });

      // Load Customers & Leads Report
      axios
        .get('/reports/marketing-activity/customers-leads/' + this.dateStart + '/' + this.dateEnd)
        .then(response => {
          this.marketingActivityData.customersLeads = response.data.data
          console.log('Marketing Activity - Customers & Leads:', response.data.data)
          this.loadedMarketingActivity = true
          // Draw the New Customer funnel after data is loaded
          this.$nextTick(() => {
            this.drawNewCustomerFunnel()
          })
        })
        .catch(e => {
          console.error('Error loading customers & leads report:', e)
          this.loadedMarketingActivity = false
        });
    },
    loadCompareReports() {
      axios
        .get('/reports/marketing-summary-social/' +  this.dateCompareStart + '/' + this.dateCompareEnd )
        .then(response => {
          this.dataCompare = response.data.data
          this.drawSocialBar()
        });
    },
    drawConversationBar(){
       Highcharts.chart('conversationFunnel', {
        chart: {
          type: 'funnel'
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              formatter: function (){
                  let str_point = ''
                  if (!this.point.realY){
                      str_point = 'N/A'
                  }
                  else{
                   str_point =  this.point.realY.toString()
                  }
                  let res =  '<b>'+this.point.name+'</b> ('+str_point.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +')'
                  return res
              },
              softConnector: true,
              inside: true,
              color:'black',
              style: {
                textOutline: false
              }
            },
            center: ['40%', '50%'],
            neckWidth: '20%',
            neckHeight: '0%',
            width: '70%',
            borderWidth: 6,
            events: {
               click: (event) => {
                 if (event.point.name === 'Orders') {
                      let orders = JSON.stringify({
                        report: 'geoSalesReport',
                        order_ids: [],
                        dateStart: this.dateStart,
                        dateEnd: this.dateEnd,
                        defaultPeriod: this.defaultPeriod
                      })
                      localStorage.setItem('orders', orders)

                      let routeData = this.$router.resolve({name: 'sales'})
                      window.open(routeData.href, '_blank')
                 }
               }
             },
          }
        },
        legend: {
          enabled: false
        },
         tooltip: {
          formatter: function() {
            let tooltip = ""
            let tooltipAsterix = "*"
            if(this.point.options.obj.tooltip){
              tooltip = "<br/><i>* " + this.point.options.obj.tooltip + "</i>"
            }

            if(tooltip === ""){
              tooltipAsterix = ""
            }

            if(this.point.name === 'PPC Clicks'){
                return this.series.name + '<br><span style="color:' + this.color + '">●</span> '
                    + this.point.name + tooltipAsterix+': <b>' + this.point.realY.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")  + '</b>' +
                    '<br><span style="color:' + this.color + '">●</span> $ cost click**: <b> $'
                    + this.point.options.obj.clickCost.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    + '</b>' + tooltip;
            }
            if(this.point.name === 'Orders'){
                return this.series.name + '<br><span style="color:' + this.color + '">●</span> '
                    + this.point.name + tooltipAsterix+': <b>' + this.point.realY.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")  + '</b>' +
                    '<br><span style="color:' + this.color + '">●</span> $ cost Order**: <b> $'
                    + this.point.options.obj.orderCost.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    + '</b>' + tooltip;
            }

            // Default tooltip for all other items (PPC Impressions, FO Events, Unique Inbound Traffic)
            return this.series.name + '<br><span style="color:' + this.color + '">●</span> ' + this.point.name + tooltipAsterix+': <b>' + this.point.realY.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")  + '</b>' + tooltip;
          }
        },
        colors: [
            {
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#546298'],
            [1, '#6a99ff']
          ]
        },{
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#549876'],
            [1, '#6affb5']
          ]
        },{
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#7D5498'],
            [1, '#C46AFF']
          ]
        }, {
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#F399E6'],
            [1, '#FFA1F2']
          ]
        }, {
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#d7292b'],
            [1, '#F95C5E']
          ]
        }, {
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#ECE05C'],
            [1, '#FFF58C']
          ]
        }],
        series: [{
          name: 'Total',
          keys: ['name', 'y', 'realY', 'obj'],
          data: [
            // Use data from Marketing Activity endpoint (get_ConversationRateReport)
            ['PPC Impressions', 1, this.marketingActivityData.conversionRate.ppc_impressions || this.data.conversion.total_impr, {tooltip:"Pay per click impressions for the selected period of time"}],
            ['PPC Clicks', 1, this.marketingActivityData.conversionRate.ppc_clicks || this.data.conversion.total_clicks, {tooltip:"Pay per click clicks for the selected period of time",
                clickCost: this.data.expenses.total/(this.marketingActivityData.conversionRate.ppc_clicks || this.data.leads.total_clicks)}],
            ['FO Events', 1, this.marketingActivityData.conversionRate.fo_events || 0, {tooltip: "FO Events created in the selected period of time"}],
            ['Unique Inbound Traffic', 1, this.marketingActivityData.conversionRate.unique_inbound_traffic || this.data.conversion.leads, {tooltip: "FO Contacts with call or web inquiry in period"}],
            ['Orders', 1, this.marketingActivityData.conversionRate.orders || this.data.conversion.orders, {orderCost: this.data.expenses.total/(this.marketingActivityData.conversionRate.orders || this.data.conversion.orders)}],
            // Keep old data for compatibility
            // ['Paid Search Users', 1, this.data.conversion.visits, {all: this.data.leads.all_visits, tooltip: "Number of individual persons browsing your website (technically, a unique browser cookie) for the selected period of time."}],
            // ['CRM Leads', 1, this.data.leads.new, {newLeadCost: this.data.leads.cost,  tooltip:"# of new leads created in the Copper (CRM) based on the calls and web inquiries."}],
            // ['Customers', 1, this.data.conversion.customers, {customerCost: this.data.expenses.total/this.data.conversion.customers}],
          ]
        }],
      });
    },
    drawNewCustomerFunnel(){
      console.log('Drawing New Customer Funnel with data:', this.marketingActivityData.customersLeads)

      // Check if element exists
      if (!document.getElementById('newCustomerFunnel')) {
        console.error('Element #newCustomerFunnel not found!')
        return
      }

      Highcharts.chart('newCustomerFunnel', {
        chart: {
          type: 'funnel'
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              formatter: function (){
                  let str_point = ''
                  if (!this.point.realY){
                      str_point = 'N/A'
                  }
                  else{
                   str_point =  this.point.realY.toString()
                  }
                  let res =  '<b>'+this.point.name+'</b> ('+str_point.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +')'
                  return res
              },
              softConnector: true,
              inside: true,
              color:'black',
              style: {
                textOutline: false
              }
            },
            center: ['40%', '50%'],
            neckWidth: '20%',
            neckHeight: '0%',
            width: '70%',
            borderWidth: 6
          }
        },
        legend: {
          enabled: false
        },
         tooltip: {
          formatter: function() {
            let tooltip = ""
            let tooltipAsterix = "*"
            if(this.point.options.obj.tooltip){
              tooltip = "<br/><i>* " + this.point.options.obj.tooltip + "</i>"
            }

            if(tooltip === ""){
              tooltipAsterix = ""
            }

            // Default tooltip for all items
            return this.series.name + '<br><span style="color:' + this.color + '">●</span> ' + this.point.name + tooltipAsterix+': <b>' + this.point.realY.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")  + '</b>' + tooltip;
          }
        },
        colors: [
            {
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#546298'],
            [1, '#6a99ff']
          ]
        },{
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#549876'],
            [1, '#6affb5']
          ]
        },{
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#7D5498'],
            [1, '#C46AFF']
          ]
        }],
        series: [{
          name: 'Total',
          keys: ['name', 'y', 'realY', 'obj'],
          data: [
            // Use data from Marketing Activity endpoint (get_Converstion_Customers_LeadsReportData)
            ['FO Events', 1, this.marketingActivityData.customersLeads.fo_events_count || 0, {tooltip: "FO Events count in the selected period of time"}],
            ['FO New Leads', 1, this.marketingActivityData.customersLeads.fo_new_leads_count || 0, {tooltip: "FO New Leads count in the selected period of time"}],
            ['FO New Customers', 1, this.marketingActivityData.customersLeads.fo_new_customers_count || 0, {tooltip: "FO New Customers count in the selected period of time"}],
          ]
        }],
      });
    },
    drawOrdersPieChart(){
      console.log('Drawing Orders Pie Chart with data:', this.marketingActivityData.orders)

      // Check if element exists
      if (!document.getElementById('ordersPieChart')) {
        console.error('Element #ordersPieChart not found!')
        return
      }

      Highcharts.chart('ordersPieChart', {
        chart: {
          type: 'pie',
          height: 500
        },
        title: {
          text: ''
        },
        tooltip: {
          formatter: function() {
            let percentage = ((this.point.y / this.point.series.data.reduce((sum, p) => sum + p.y, 0)) * 100).toFixed(1)
            return '<b>' + this.point.name + '</b>: ' + this.point.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' (' + percentage + '%)'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y}',
              style: {
                color: 'black',
                textOutline: 'none'
              }
            },
            showInLegend: true,
            size: '80%'
          }
        },
        legend: {
          enabled: true,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal'
        },
        colors: ['#6affb5', '#C46AFF', '#FFA1F2'],
        series: [{
          name: 'Orders',
          colorByPoint: true,
          data: [
            {
              name: 'Converted Leads',
              y: this.marketingActivityData.orders.converted_lead_to_customer || 0
            },
            {
              name: 'New Customers',
              y: this.marketingActivityData.orders.new_customer || 0
            },
            {
              name: 'Recurrent Customers',
              y: this.marketingActivityData.orders.recurrent_customer || 0
            }
          ]
        }]
      });
    },

    drawQuotesPieChart(){
      console.log('Drawing Quotes Pie Chart with data:', this.marketingActivityData.quotes)

      // Check if element exists
      if (!document.getElementById('quotesPieChart')) {
        console.error('Element #quotesPieChart not found!')
        return
      }

      Highcharts.chart('quotesPieChart', {
        chart: {
          type: 'pie',
          height: 500
        },
        title: {
          text: ''
        },
        tooltip: {
          formatter: function() {
            let percentage = ((this.point.y / this.point.series.data.reduce((sum, p) => sum + p.y, 0)) * 100).toFixed(1)
            return '<b>' + this.point.name + '</b>: ' + this.point.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' (' + percentage + '%)'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y}',
              style: {
                color: 'black',
                textOutline: 'none'
              }
            },
            showInLegend: true,
            size: '80%'
          }
        },
        legend: {
          enabled: true,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal'
        },
        colors: ['#6affb5', '#FFAC19', '#FF6B6B'],
        series: [{
          name: 'Quotes',
          colorByPoint: true,
          data: [
            {
              name: 'Converted',
              y: this.marketingActivityData.quotes.converted_quotes || 0
            },
            {
              name: 'Open',
              y: this.marketingActivityData.quotes.open_quotes || 0
            },
            {
              name: 'Lost',
              y: this.marketingActivityData.quotes.lost_quotes || 0
            }
          ]
        }]
      });
    },
    drawRelevanceBar(){
      let total = this.data.relevancy.call + this.data.relevancy.web;
      let cPct = 0; let wPct = 0;
      if (total > 0) {
        cPct = (this.data.relevancy.call/total * 100).toFixed(2);
        wPct = (this.data.relevancy.web/total * 100).toFixed(2);
      }
      Highcharts.chart('relevancyBar', {
          chart: {
              type: 'timeline'
          },
          plotOptions:{
            series:{
              events: {
               click: (event) => {
                 if (event.point.name.indexOf("Callrail") > -1) {
                      let routeData = this.$router.resolve({name: 'call-center'})
                      window.open(routeData.href, '_blank')
                 }
                 if (event.point.name.indexOf("inquiries") > -1) {
                      let routeData = this.$router.resolve({name: 'inquires'})
                      window.open(routeData.href, '_blank')
                 }
               }
             },
            }
          },
          xAxis: {
              visible: false
          },
          yAxis: {
              visible: false
          },
          title: {
              text: 'All Inbound traffic (details)'
          },
          colors: [
              '#21A3DB',
              '#6F53C0',
          ],
          series: [{
              data: [{
                  name: '# of inbound Callrail calls ('+this.data.relevancy.call+', '+cPct+'%)',
              }, {
                  name: '# of web inquiries ('+this.data.relevancy.web+', '+wPct+'%)',
              }]
          }]
      });

      Highcharts.chart('relevancyFunnel', {
        chart: {
          type: 'funnel'
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              formatter: function (){return  '<b>'+this.point.name+'</b> ('+this.point.realY.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +')' },
              softConnector: true,
              inside: true,
              color:'black',
              style: {
                textOutline: false
              }
            },
            center: ['40%', '50%'],
            neckWidth: '20%',
            neckHeight: '0%',
            width: '70%',
            borderWidth: 6,
            events: {
               click: (event) => {
                 if (event.point.name.indexOf("Potential") > -1) {
                      let data = JSON.stringify({
                        report: 'potential-gallon',
                        dateStart: this.dateStart,
                        dateEnd: this.dateEnd,
                        defaultPeriod: this.defaultPeriod
                      })
                      localStorage.setItem('potential-gallon', data)

                      let routeData = this.$router.resolve({name: 'potential-gallon'})
                      window.open(routeData.href, '_blank')
                 }
               }
             },
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function() {
            let tooltip = ""
            let tooltipAsterix = "*"
            if(this.point.options.obj.tooltip){
              tooltip = "<br/><i>* " + this.point.options.obj.tooltip + "</i>"
            }

            if(tooltip === ""){
              tooltipAsterix = ""
            }


            return this.series.name + '<br><span style="color:' + this.color + '">●</span> ' + this.point.name + tooltipAsterix+': <b>' + this.point.realY.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")  + '</b>' + tooltip;
          }
        },
        colors: [{
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#6F53C0'],
            [1, '#C3AEFF']
          ]
        },
          {
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#c0b753'],
            [1, '#ffe8ae']
          ]
        },{
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [
            [0, '#FDE359'],
            [1, '#EECB4E']
          ]
        }],
        series: [{
          name: 'Total',
          keys: ['name', 'y', 'realY', 'obj'],
          data: [
            ['All Inbound traffic', 1, this.data.relevancy.call + this.data.relevancy.web, {tooltip:"All inbound CallRail calls and Web Inquirie"}],
            ['Unique Events', 1, this.data.conversion.leads, {tooltip: "Number of unique requests: inbound calls and web inquiries"}],
              ['CRM Leads', 1, this.data.leads.new, {newLeadCost: this.data.leads.cost,  tooltip:"# of new leads created in the Copper (CRM) based on the calls and web inquiries."}],
            // ['# of Potential Quotes ', 1, this.data.relevancy.quotes, {}],
          ]
        }],
      });
    },
    drawSocialBar(){
      let fullName = new Date(this.dateEnd).getDate() + ' ' + this.monthNames[new Date(this.dateEnd).getMonth()] + ' ' + new Date(this.dateEnd).getFullYear()
      let series = [{
            name: this.monthNames[new Date(this.dateEnd).getMonth()] + ' ' + new Date(this.dateEnd).getFullYear(),
            data: [
                {y:this.data.media.facebook, color:"rgba(94,108,176,0.87)", name:fullName},
                {y:this.data.media.instagram, color:"#FDD69C", name:fullName},
                {y:this.data.media.linkedin, color:"#FFA1F2", name:fullName},
                {y:this.data.media.youtube, color:"#FF9D9D", name:fullName},
                {y:this.data.media.twitter, color:"#8698FA", name:fullName}
            ]
        }]
      if (this.isCompareFilter){
        let fullName = new Date(this.dateCompareEnd).getDate() + ' ' + this.monthNames[new Date(this.dateCompareEnd).getMonth()] + ' ' + new Date(this.dateCompareEnd).getFullYear()

        series.push({
            name: this.monthNames[new Date(this.dateCompareEnd).getMonth()] + ' ' + new Date(this.dateCompareEnd).getFullYear(),
            data:[
                {y:this.dataCompare.media.facebook, color:"rgba(124,134,187,0.93)", name:fullName},
                {y:this.dataCompare.media.instagram, color:"#FBD9B1", name:fullName},
                {y:this.dataCompare.media.linkedin, color:"#FECDF7", name:fullName},
                {y:this.dataCompare.media.youtube, color:"#FCB8B7", name:fullName},
                {y:this.dataCompare.media.twitter, color:"#D6DCFF", name:fullName}
            ]
        })
      }
      this.socialBar.series = series
    }
  }
}
</script>

<style scoped>
  .btn-right-arrow {
    right: 0px;
    top: 65px;
  }
  .btn-left-arrow {
    left: 0px;
    top: 65px;
  }
</style>
